import { Injectable } from '@angular/core'
import {
    TranslateService, TranslateStore

} from '@ngx-translate/core'
@Injectable({ providedIn: 'root' })
export class EnglishTranslateService extends TranslateService {

    constructor(translate: TranslateService) {
        const translateStore = new TranslateStore()
        translateStore.translations = translate.store.translations
        super(translateStore, translate.currentLoader, translate.compiler, translate.parser, translate.missingTranslationHandler, true, false, true, 'en')
        this.use('en')
    }
}
